import { create } from 'zustand';
import type { EventSet, FontMeta } from '@cal/engine';
import { get } from './api';

export interface FontInfo { id: string; family: string; weight: number; style: string; sha256: string; source: 'curated' | 'uploaded'; license: string }
export interface User { id: string; email: string; name: string; role: 'admin' | 'staff' }
export interface LibraryEventSet extends EventSet { updatedAt: string; verifiedBy: string | null }

interface Lib {
  user: User | null;
  fonts: FontInfo[];
  eventSets: LibraryEventSet[];
  loadFonts: () => Promise<void>;
  loadEventSets: () => Promise<void>;
}

export const useLibrary = create<Lib>((set) => ({
  user: null,
  fonts: [],
  eventSets: [],
  loadFonts: async () => set({ fonts: (await get<{ fonts: FontInfo[] }>('/api/fonts')).fonts }),
  loadEventSets: async () => set({ eventSets: (await get<{ eventSets: LibraryEventSet[] }>('/api/event-sets')).eventSets }),
}));

export const fontMeta = (f: FontInfo): FontMeta => ({ id: f.id, family: f.family, weight: f.weight, style: 'normal', sha256: f.sha256, source: f.source });
